import { t } from '@lingui/macro';
import { isBefore, startOfToday } from 'date-fns';
import * as yup from 'yup';
const schema = yup.object({
    title: yup
        .string()
        .trim()
        .required(t `Task title is required.`),
    description: yup.string().trim(),
    isPublic: yup.bool().required(),
    isCompleted: yup.bool().required(),
    assigneeId: yup.string().trim(),
    dueDate: yup
        .string()
        .trim()
        .when('reminder', {
        is: (reminder) => Boolean(reminder === null || reminder === void 0 ? void 0 : reminder.dueDate),
        then: dueDate => dueDate.required(t `Due date is required to specify reminder`),
    }),
    reminder: yup.object({
        id: yup.string(),
        dueDate: yup
            .string()
            .trim()
            .test('incorrect-date', t({
            message: 'Reminder can not be set to a date in the past',
            comment: 'Error message if the selected reminder date is in the past',
        }), dueDate => {
            if (!dueDate) {
                return true;
            }
            return isBefore(startOfToday(), new Date(dueDate));
        }),
    }),
});
export { schema };
